var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCrossNumber = function SvgCrossNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#004586",
    d: "M12.76 15.5 8.233 9.83l4.254-5.174h.932L9.293 9.502l-.265.31.252.322 2.413 3.087 1.782 2.279zM7.089 9.826V15.5h-.62V4.656h.62v3.743z",
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    stroke: "#004586",
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgCrossNumber as ReactComponent };
export default __webpack_public_path__ + "feb6bdfc7bea8ea16b369db0a049addf.svg";